import React, { useState } from 'react'
import { useEffect } from 'react'
import EmptySeatResult from './EmptySeatResult'
import Select from './input/Select'

export default function CheckEmptySeatFilter({ emptySeatsEventObj, getEventId, setEmptySeatsEventObj }) {
    const [date, setDate] = useState(null)
    const [tripType, setTripType] = useState(null)
    const [round, setRound] = useState(null)
    const [results, setResults] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const handleChange = (e) => {
        const { name, value } = e.target
        console.log(`${name} || ${value}`)
        if (name === "date") {
            setDate(value)
            setTripType(null)
            setRound(null)
            if (!value) {
                setTripType(null)
                setRound(null)
            }
        }
        else if (name === "tripType") {
            setTripType(value)
            if (!value) {
                setRound(null)
            }
        }
        else if (name === "round") {
            setRound(value)
        }
    }

    useEffect(() => { setIsLoading(false) }, [])

    return (
        <div className='row'>
            <div className='col-xs-12 col-sm-12 col-md-4'>
                <Select
                    name="date"
                    value={date || ""}
                    label="วันที่"
                    options={emptySeatsEventObj.dates}
                    // disabled={isDisabled}
                    formText={null}
                    // isInvalid={isDateInvalid}
                    handleChange={handleChange}
                    inputMsg="วันที่"
                />
            </div>
            <div className='col-xs-12 col-sm-12 col-md-4'>
                <Select
                    name="tripType"
                    value={tripType || ""}
                    label="ประเภทการเดินทาง"
                    options={emptySeatsEventObj.tripTypes}
                    disabled={!date}
                    formText={null}
                    // isInvalid={isDateInvalid}
                    handleChange={handleChange}
                    inputMsg="ประเภท"
                />
            </div>
            <div className='col-xs-12 col-sm-12 col-md-4'>
                <Select
                    name="round"
                    value={round || ""}
                    label="รอบการเดินทาง"
                    options={emptySeatsEventObj.rounds.filter(e => e.dateTime === date)}
                    disabled={!date || !tripType}
                    formText={null}
                    // isInvalid={isDateInvalid}
                    handleChange={handleChange}
                    inputMsg="รอบ"
                />
                <br />
            </div>
            <div className='col-xs-12 col-sm-12 col-md-12'>
                <div className='d-grid gap-2 d-md-flex justify-content-md-end'>
                    <button
                        className='btn btn-primary'
                        onClick={async () => {
                            if (date && round && tripType) {
                                setIsLoading(true)
                                setTimeout(() => {
                                    setIsLoading(false)
                                }, 1000);
                                await getEventId()
                                if (emptySeatsEventObj) {
                                    if (emptySeatsEventObj.results) {
                                        let newArr = []
                                        for (let obj of emptySeatsEventObj.results) {
                                            // console.log(obj)
                                            // console.log(ob.dateTime === dateTime)
                                            // console.log(ob.name === round)
                                            if (obj.dateTime === date && obj.name === round) {
                                                newArr.push(obj)
                                            }
                                        }
                                        setResults(newArr[0].routes)
                                    }
                                }
                            }
                        }}
                        disabled={!date || !round || !tripType}
                    >เช็คที่นั่งว่าง</button>
                </div>
            </div>
            <EmptySeatResult
                results={results}
                eventId={emptySeatsEventObj._id}
                status={emptySeatsEventObj.status}
                isLoading={isLoading}
            />
        </div>
    )
}
